import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {InstallBidService} from "../../core/services/install-bid.service";
import {RequestStatusEnum} from "../../core/enums/request-status.enum";
import {ProjectInstallBidDetail} from "../../core/models/project-install-bid-detail.interface";
import {InstallerCrew} from "../../core/models/installer-crew.interface";
import {addDays, startOfDay, subDays, subWeeks} from "date-fns";

@Component({
  selector: 'app-install-bids',
  templateUrl: './install-bids.component.html',
  styleUrls: ['./install-bids.component.scss']
})
export class InstallBidsComponent implements OnInit {

  projectInstallBidDetails: ProjectInstallBidDetail[] = [];
  installerId: number = 0;

  installerCrew: InstallerCrew[];

  selectedInstall: ProjectInstallBidDetail;

  activeInactiveBoolean: boolean = true;

  filter = '';
  filterType = '';

  busy: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private installBidService: InstallBidService,
    ) {
  }

  ngOnInit() {
    let currentRoute = this.route;
    while (currentRoute.children[0]) {
      currentRoute = currentRoute.children[0];
    }
    this.route.parent?.paramMap.subscribe(params => {
      this.installerId = +params.get('installerId')!;
      this.getInstalls();
    });
  }

  getInstalls() {
    this.busy = true;
    this.installBidService.getInstallerBids(this.installerId, this.activeInactiveBoolean).subscribe({
      next: (installerBids) => {
        this.projectInstallBidDetails = installerBids.bidDetails;
        this.installerCrew = installerBids.crew;
        if(installerBids.requiredCompliance) {
          this.projectInstallBidDetails.forEach(bid => bid.requiredCompliance = installerBids.requiredCompliance);
        }
        this.busy = false;
      },
      error: (err) => {
        this._snackBar.open('Get Bid Request Failed: ' + err.error.message);
        this.busy = false;
      }
    });
  }

  get filteredProjectInstallBidDetails() {
    return this.projectInstallBidDetails.filter(
      (install) =>
        (this.filterType === '' ||
          (this.filterType === 'won' && install.request.bidStatus === RequestStatusEnum.ACCEPTED) ||
          (this.filterType === 'await' && install.request.bidStatus === RequestStatusEnum.PENDING && !install.request.bidAmount) ||
          (this.filterType === 'bid' && install.request.bidStatus === RequestStatusEnum.PENDING && install.request.bidAmount) ||
          (this.filterType === 'lost' && install.request.bidStatus === RequestStatusEnum.REJECTED)) &&
        (install.title?.toLowerCase().includes(this.filter.toLowerCase()) ||
          install.description?.toLowerCase().includes(this.filter.toLowerCase()) ||
          install.project.orderNo?.toLowerCase().includes(this.filter.toLowerCase()) ||
          install.project.city?.toLowerCase().includes(this.filter.toLowerCase()) ||
          install.project.state?.toLowerCase().includes(this.filter.toLowerCase()))
    ).sort((a, b) => {
      if (a.project.installDate > b.project.installDate) {
        return 1;
      } else if (a.project.installDate < b.project.installDate) {
        return -1;
      }
      return 0;
    });
  }

  selectInstall(install: ProjectInstallBidDetail) {
    this.selectedInstall = install;
  }

  dueDate(date: Date | string | undefined, installDate: Date | string) {
    if(date) {
      return startOfDay(new Date(date));
    }
    return startOfDay(subWeeks(new Date(installDate), 2));;
  }

  bidAccepted(install: ProjectInstallBidDetail) {
    return install.request.bidStatus === RequestStatusEnum.ACCEPTED && (!install.bidSequence || install.bidSequence === 0);
  }

  getInstallCrew(install: ProjectInstallBidDetail) {
    let crewName = '';
    if(this.installerCrew) {
      let crew = this.installerCrew.find((c) => c.id === install.request.bidCrewId);
      if (crew) {
        crewName = crew.fullName;
      }
    }
    return crewName;
  }

  handleCrewChange(crewId: number | undefined) {
    this.selectedInstall.request.bidCrewId = crewId;
  }

  activeInactiveToggle() {
    this.activeInactiveBoolean = !this.activeInactiveBoolean;
    this.filterType = '';
    this.getInstalls();
  }

  openStatusDescription(install: ProjectInstallBidDetail) {
    if(install.request.bidStatus === RequestStatusEnum.WITHDRAWN) {
      return 'Withdrawn';
    }
    if(install.request.bidStatus === RequestStatusEnum.NOT_BIDDING) {
      return 'Not Bidding';
    }
    if(install.request.bidStatus === RequestStatusEnum.REJECTED) {
      return 'Rejected';
    }
    return 'Not Sent';
  }
}
